import { apiFetch, apiFetchEnvelope, type ListMeta } from "@core/http";
import type { components } from "@core/types/openapi";

export type NotificationCampaignInput =
  components["schemas"]["NotificationCampaignInput"];
export type NotificationCampaignSummary =
  components["schemas"]["NotificationCampaignSummary"];
export type NotificationCampaignDetail =
  components["schemas"]["NotificationCampaignDetail"];
export type MemberSummary = components["schemas"]["MemberSummary"];

const base = "/v1/portal/notifications";

export interface NotificationCampaignPage {
  items: NotificationCampaignSummary[];
  meta: ListMeta;
}

export const listNotificationCampaigns = async (
  cursor?: string,
): Promise<NotificationCampaignPage> => {
  const params = new URLSearchParams({ limit: "20" });
  if (cursor) params.set("cursor", cursor);
  const envelope = await apiFetchEnvelope<NotificationCampaignSummary[]>(
    `${base}?${params.toString()}`,
  );
  return {
    items: envelope.data,
    meta: envelope.meta ?? { next: null, total: envelope.data.length },
  };
};

export const getNotificationCampaign = (id: string) =>
  apiFetch<NotificationCampaignDetail>(`${base}/${encodeURIComponent(id)}`);

export const createNotificationCampaign = (
  input: NotificationCampaignInput,
  idempotencyKey: string,
) =>
  apiFetch<NotificationCampaignSummary>(base, {
    method: "POST",
    body: input,
    idempotencyKey,
  });

export const listActiveMembers = async (
  search: string,
): Promise<MemberSummary[]> => {
  const params = new URLSearchParams({ active: "true", limit: "20" });
  if (search.trim()) params.set("search", search.trim());
  const envelope = await apiFetchEnvelope<MemberSummary[]>(
    `/v1/portal/members?${params.toString()}`,
  );
  return envelope.data;
};
